// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".language-switch-dropdown[data-v-2ca3c2a6] .ivu-dropdown-rel{cursor:pointer}", ""]);
// Exports
module.exports = exports;
